<template>
  <section class="content">
    <h2 class="subtitle" v-html="aboutHeader" />
    <div class="columns is-multiline">
      <div
        v-for="(field, key) in allFields"
        :key="key"
        :class="computeFieldClass(field)"
        :id="`${field}-container`"
      >
        <label
          :for="field.name"
          class="field-label has-text-weight-bold"
          v-if="field.type !== 'html' && field.label"
          v-html="field.label"
        />
        <div v-if="field.type === 'nomination'">
          <Nomination />
        </div>
        <div class="field-body" v-else-if="field.nested">
          <div class="field" v-for="(subfield, key) in field.nested" :key="key">
            <FormHtml :field="subfield" v-if="subfield.type === 'html'"></FormHtml>
            <FormSelect :field="subfield" v-else-if="subfield.type === 'select'"></FormSelect>
            <FormTextArea :field="subfield" v-else-if="subfield.type === 'textarea'"></FormTextArea>
            <FormInput :field="subfield" v-else></FormInput>
          </div>
        </div>
        <div class="field-body" v-else>
          <div class="field">
            <FormHtml :field="field" v-if="field.type === 'html'"></FormHtml>
            <FormSelect :field="field" v-else-if="field.type === 'select'"></FormSelect>
            <FormSlider :field="field" v-else-if="field.type === 'slider'"></FormSlider>
            <FormTextArea :field="field" v-else-if="field.type === 'textarea'"></FormTextArea>
            <FormRadio :field="field" v-else-if="field.type === 'radio'"></FormRadio>
            <FormCheckbox :field="field" v-else-if="field.type === 'checkbox'"></FormCheckbox>
            <FormInput :field="field" v-else></FormInput>
          </div>
        </div>
      </div>
    </div>
    <hr>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import FormInput from '@/components/Form/Input.vue';
import FormSelect from '@/components/Form/Select.vue';
import FormTextArea from '@/components/Form/TextArea.vue';
import FormHtml from '@/components/Form/Html.vue';
import FormSlider from '@/components/Form/Slider.vue';
import FormRadio from '@/components/Form/Radio.vue';
import FormCheckbox from '@/components/Form/Checkbox.vue';
import Nomination from '@/components/Nomination.vue';

export default {
  computed: {
    ...mapGetters({
      allFields: 'fields',
    }),
    aboutHeader() {
      return this.$store.state.about_header;
    },
  },
  methods: {
    computeFieldClass(field) {
      const classes = ['is-horizontal', 'column', 'is-12', 'is-marginless', `${field.type}-container`];
      if (field.type !== 'nomination') {
        classes.push('field');
      }
      return classes;
    },
  },
  components: {
    FormInput,
    FormSelect,
    FormSlider,
    FormTextArea,
    FormHtml,
    FormRadio,
    FormCheckbox,
    Nomination,
  },
};
</script>
